const _groupSize = 3;

function formatNIT(nit : string) : string {
  const nitWithoutDigit = getNITWithoutDigit(nit);
  const digit = getNITDigit(nit);

  return `${formatNITGroups(nitWithoutDigit)}-${digit}`;
}

function getNITWithoutDigit(nit : string) : string {
  return nit.substring(0, nit.length -1);
}

function countGroupParts(nit : string) : number {
  return Math.ceil(nit.length / _groupSize);
}

function formatNITGroups(nit : string) : string {
  const parts = countGroupParts(nit);
  const groups = new Array(parts);

  let endPosition = _groupSize;

  for (let i = 0; i < parts; ++i) {
    groups[i] = nit.substring((i * _groupSize), endPosition);
    endPosition += _groupSize;
  }

  return `${groups.join('.')}`;
}

function getNITDigit(nit : string) : string {
  return nit.substring(nit.length -1);
}

export default formatNIT;